/**
 * Written by `AnimateNumber`, read back by the portals client-error counter snapshot. Constants because
 * the two sides live in different packages; its own module so the client entry skips the component.
 */
export const COUNTER_VALUE_ATTR = 'data-value';
export const COUNTER_MODE_ATTR = 'data-counter-mode';

/**
 * An `entrance` line renders zero on both sides, so it can never show a mismatch: TEC-3804 arrived with a
 * #418 `args[]=text` whose every line read `…=>0`.
 *
 * `static` is a non-counter formatted once, so a disagreement is real: the same number formatted
 * differently means different locales (TEC-3689); different numbers mean the query did not hydrate from
 * the SSR payload (TEC-3758, or the lost hydration the router-core patch describes).
 */
export const COUNTER_MODE_INSTANT = 'instant';
export const COUNTER_MODE_ENTRANCE = 'entrance';
export const COUNTER_MODE_STATIC = 'static';
// React does not patch attributes on hydration, so this names the side that used the wrong locale (TEC-3696).
export const COUNTER_LOCALE_ATTR = 'data-counter-locale';
